import {
  CreateInternalApplicationDocument,
  CreateInternalApplicationMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateInternalApplication = () => {
  const [createInternalApplication, { loading }] = useMutation(CreateInternalApplicationDocument, {
    awaitRefetchQueries: true,
    extractorFn: (data) => data.atsMutations.createFromEmployeeAtsApplication,
  })

  return {
    loading,
    create(variables: CreateInternalApplicationMutationVariables) {
      return createInternalApplication({
        variables,
      })
    },
  }
}
